import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from './en.json';
import es from './es.json';

const resources = {
    en: { translation: en },
    es: { translation: es },
};

const SUPPORTED_LANGUAGES = ['en', 'es'];
const PREFERRED_LANGUAGE_KEY = 'preferredLanguage';

function bootstrapLanguage(): string {
    const stored = window.localStorage.getItem(PREFERRED_LANGUAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
        return stored;
    }

    const browserLanguage = window.navigator.language?.slice(0, 2).toLowerCase();
    if (browserLanguage && SUPPORTED_LANGUAGES.includes(browserLanguage)) {
        return browserLanguage;
    }

    return 'en';
}

i18n.use(initReactI18next).init({
    resources,
    compatibilityJSON: 'v3',
    lng: bootstrapLanguage(),
    fallbackLng: "es",
    interpolation: {
        escapeValue: false,
    },
});

i18n.on('languageChanged', (lng) => {
    window.localStorage.setItem(PREFERRED_LANGUAGE_KEY, lng);
});

export default i18n;
